import React, { useCallback, useContext, useEffect, useState, } from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import IconButton from '../../../Buttons/IconButton';
import { IconChevronLeft } from '../../../__generated__';
import Heading from '../../../Typography/Heading';
import { DeviceManagerContext } from '@trainline-shareable/device-manager';
import { ModalParentWrapperContext, modalPrefix } from '..';
import * as styles from './style.module.css';
import { setMultipleRefs } from '../../../_shared/helpers';
const HeaderWithoutRef = ({ headerText, headerAction, backButtonCallback, innerRef, className, id, ...commonProps }) => {
    // States
    const [headerHeight, setHeaderHeight] = useState(0);
    // Contexts
    const deviceManager = useContext(DeviceManagerContext);
    const { mobileModalOptions: { size: mobileModalSize, resizable }, setHeadingId, } = useContext(ModalParentWrapperContext);
    // Derived values
    const isMobileViewport = /(X?S)/.test((deviceManager === null || deviceManager === void 0 ? void 0 : deviceManager.viewPort) || 'S');
    // Classes
    const headerShadowClasses = clsx(styles.headerShadow);
    const headerWrapperClasses = clsx(styles.header, {
        [styles.mobileViewport]: isMobileViewport,
        [styles.resizable]: resizable && mobileModalSize === 'small',
        [styles.largeMobileModal]: mobileModalSize === 'large',
    });
    const headingContainerClasses = clsx(styles.headingContainer);
    const headerActionClasses = clsx(styles.headerAction, {
        [styles.mobileViewport]: isMobileViewport,
    });
    const innerDivClasses = clsx(className, headerWrapperClasses);
    const headerRef = useCallback((element) => {
        if (element && isMobileViewport) {
            setHeaderHeight(element.clientHeight);
        }
    }, [isMobileViewport]);
    // IDs
    const headingId = `${modalPrefix}-heading-${id}`;
    useEffect(() => {
        setHeadingId === null || setHeadingId === void 0 ? void 0 : setHeadingId(headingId);
    }, [setHeadingId, headingId]);
    return (React.createElement(React.Fragment, null,
        Depot.createElement('div', {
            ...commonProps,
            className: innerDivClasses,
            innerRef: setMultipleRefs([headerRef, innerRef]),
        }, React.createElement(React.Fragment, null,
            React.createElement("div", { className: headingContainerClasses },
                backButtonCallback && (React.createElement(IconButton, { testId: "backButton", icon: IconChevronLeft, size: "large", iconSize: 32, "aria-label": "back", onClick: backButtonCallback })),
                React.createElement(Heading, { id: headingId, typeStyle: "title2", as: "h2" }, headerText)),
            React.createElement("div", { className: headerActionClasses }, headerAction))),
        isMobileViewport && (React.createElement("div", { className: headerShadowClasses, style: { top: `${headerHeight}px` } }))));
};
const Header = Depot.withRef(HeaderWithoutRef);
Header.displayName = 'Header';
export default Header;
//# sourceMappingURL=index.js.map